import React from 'react'
import PropTypes from 'prop-types'
import ChannelIcon from 'components/ChannelIcon'
import ConversionIcon from 'components/ConversionIcon'
import {TooltipTable, TooltipRow, TooltipCell} from 'components/Tooltip'
import formatTimeRange from 'utils/formatTimeRange'
import DayTime from 'components/DayTime'
import WithTooltip from 'components/WithTooltip'
import classnames from 'classnames'
import * as _ from 'lodash'
import {channelTypes} from '@divvit/common-channels'

const utmTags = [
  'utm_medium',
  'utm_source',
  'utm_campaign',
  'utm_term',
  'utm_content'
]

export default class Touchpoint extends React.Component {
  static propTypes = {
    active: PropTypes.bool,
    touchpoint: PropTypes.object,
    disabled: PropTypes.bool
  }

  render() {
    const {touchpoint, active, disabled} = this.props
    const classNames = classnames('orders-view_touchpoint', {
      'is-disabled': disabled
    })

    if (touchpoint.type === 'conversion') {
      return this.renderConversion()
    }

    return (
      <>
        {this.renderImpression()}
        <WithTooltip
          disabled={disabled}
          title={this.renderTooltip()}
          place='top'
        >
          <div className={classNames}>
            <ChannelIcon
              disabled={disabled}
              name={touchpoint.channel}
              group={touchpoint.channelGroup}
              active={active}
            />
             {
                touchpoint.channelType && touchpoint.channelType != 'N/A' && <div className='orders-view_touchpoint_type'>
                  {channelTypes[touchpoint.channelType]?.acronym}
                </div>
              }
          </div>
        </WithTooltip>
      </>
    )
  }

  renderConversion = () => {
    const {touchpoint, disabled} = this.props

    return (
      <div className='orders-view_touchpoint'>
        <ConversionIcon
          disabled={disabled}
          name={touchpoint.conversionType}
          tooltip={(
            <TooltipTable>
              <TooltipRow>
                <TooltipCell>Conversion</TooltipCell>
                <TooltipCell color='white'>
                  {touchpoint.conversionType}
                </TooltipCell>
              </TooltipRow>
              <TooltipRow>
                <TooltipCell>Time</TooltipCell>
                <TooltipCell color='white'>
                  <DayTime date={touchpoint.startedAt} day time />
                </TooltipCell>
              </TooltipRow>
            </TooltipTable>
          )}
        />
      </div>
    )
  }

  renderImpression = () => {
    const {touchpoint, active, disabled} = this.props
    if (!touchpoint.impressions?.length) {
      return <></>
    }

    let impresionsGroups = _.groupBy(touchpoint.impressions, impression => {
      return impression.group.toLowerCase() + impression.channel.toLowerCase()
    })

    impresionsGroups = _.sortBy(impresionsGroups, [
      group => {
        const minlastView = _.minBy(group, 'lastView')
        return minlastView['lastView']
      }
    ])

    return (
      <>
        {_.map(impresionsGroups, group => {
          return (
            <>
              <WithTooltip
                disabled={disabled}
                title={this.renderImpressionTooltip(
                  _.orderBy(group, 'lastView', 'desc')
                )}
                place='top'
              >
                <div className='orders-view_touchpoint'>
                  <ChannelIcon
                    disabled={disabled}
                    name={group[0].channel.toLowerCase()}
                    group={group[0].group.toLowerCase()}
                    active={active}
                    className='is-impression'
                  />
                  {
                    group[0].channelType && <div className='orders-view_touchpoint_type'>
                      {channelTypes[group[0].channelType]?.acronym}
                    </div>
                  }
                  {/* <Icon
            disabled={disabled}
            className='channel-icon_icon'
            name={`eye`}
          /> */}
                </div>
              </WithTooltip>
              <div className='orders-view_touchpoint_link' />
            </>
          )
        })}
      </>
    )
  }

  renderImpressionTooltip = impressions => {
    return (
      <TooltipTable>
        {impressions.map((impression, index) => {
          return (
            <div key={index}>
              {index > 0 ? <br /> : null}
              <TooltipRow>
                <TooltipCell>{impression.viewCount} views</TooltipCell>
              </TooltipRow>
              <TooltipRow>
                <TooltipCell>Last view</TooltipCell>
                <TooltipCell color='white'>
                  <DayTime date={impression.lastView} day time />
                </TooltipCell>
              </TooltipRow>
              <TooltipRow>
                <TooltipCell>Channel</TooltipCell>
                <TooltipCell color='white'>{impression.group}/{impression.channel}</TooltipCell>
              </TooltipRow>
              <TooltipRow>
                <TooltipCell>Channel Type</TooltipCell>
                <TooltipCell color='white'>{channelTypes[impression.channelType].label || impression.channelType}</TooltipCell>
              </TooltipRow>
              <TooltipRow>
                <TooltipCell>Campaign</TooltipCell>
                <TooltipCell color='white'>{impression.campaign}</TooltipCell>
              </TooltipRow>
            </div>
          )
        })}
      </TooltipTable>
    )
  }

  renderTooltip = () => {
    const {touchpoint} = this.props
    const virtual = touchpoint.virtual || {}

    return (
      <TooltipTable>
        <TooltipRow>
          <TooltipCell>Channel</TooltipCell>
          <TooltipCell color='white'>
            {touchpoint.channelGroup} / {touchpoint.channel}
          </TooltipCell>
        </TooltipRow>
        <TooltipRow>
          <TooltipCell>Channel Type</TooltipCell>
          <TooltipCell color='white'>
            {channelTypes[touchpoint.channelType]?.label || touchpoint.channelType}
          </TooltipCell>
        </TooltipRow>
        <TooltipRow>
          <TooltipCell>Campaign</TooltipCell>
          <TooltipCell color='white'>
            {touchpoint.campaign || 'N/A'}
          </TooltipCell>
        </TooltipRow>
        <TooltipRow>
          <TooltipCell>Device</TooltipCell>
          <TooltipCell color='white'>{touchpoint.device}</TooltipCell>
        </TooltipRow>
        <TooltipRow>
          <TooltipCell>Landing page</TooltipCell>
          <TooltipCell color='white'>
            <span className='orders-view_touchpoint_limit'>
              {touchpoint.landingPage}
            </span>
          </TooltipCell>
        </TooltipRow>
        <TooltipRow>
          <TooltipCell>Page views</TooltipCell>
          <TooltipCell color='white'>{touchpoint.pageviewCount}</TooltipCell>
        </TooltipRow>
        <TooltipRow>
          <TooltipCell>Session start</TooltipCell>
          <TooltipCell color='white'>
            <DayTime date={touchpoint.startedAt} day time />
          </TooltipCell>
        </TooltipRow>
        <TooltipRow>
          <TooltipCell>Duration</TooltipCell>
          <TooltipCell color='white'>
            {formatTimeRange(touchpoint.startedAt, touchpoint.endedAt)}
          </TooltipCell>
        </TooltipRow>
        {utmTags.map(key => {
          const value = virtual[key]
          if (!value) return null

          return (
            <TooltipRow key={key}>
              <TooltipCell>{key}</TooltipCell>
              <TooltipCell color='white'>{virtual[key]}</TooltipCell>
            </TooltipRow>
          )
        })}
      </TooltipTable>
    )
  }
}



// WEBPACK FOOTER //
// ./client/views/OrdersInsightView/Touchpoint.js